import { useCallback, useEffect, useState } from "react";
import { useService } from "../../../../../hooks";

export const useUserTotal = ({ data, action }) => {
  const { fetch } = useService("DashboardWidget");
  const { getFormattedDate } = useService("Misc");
  const defaultQuery = {
      table: "user",
      filter: {
        date: {
          start: getFormattedDate(new Date("01-01-1990")),
          end: getFormattedDate(new Date()),
        },
      },
      attr: {},
    },
    [count, setcount] = useState<number>(0),
    [role, setrole] = useState(null),
    [title, settitle] = useState(data.title),
    [query, setquery] = useState(
      Object.keys(data.setting).length ? data.setting : defaultQuery
    );

  const fetchCount = useCallback(async () => {
    let result = await fetch("count", query);
    if (result.status) setcount(result.data);
  }, [fetch, query]);

  const applyFilters = useCallback(
    async (e) => {
      e.preventDefault();
      let queryData = query;
      queryData.attr = { role: role?.value };
      await setquery(queryData);
      fetchCount();
      action.updateWidget({
        ...data,
        title,
        configure: false,
        setting: queryData,
      });
    },
    [action, data, fetchCount, query, role?.value, title]
  );

  const changeRole = (e) => setrole(e);

  const setWidgetTitle = (e) => settitle(e.target.value);

  useEffect(() => {
    fetchCount();
  }, [fetchCount]);
  return {
    applyFilters,
    setWidgetTitle,
    title,
    role,
    changeRole,
    count,
  };
};
